/* Add icons to external links, this also takes care of the other sites */
jQuery(function() {
    //External link is not applied if the link url contains some of the following:
    var excludedStrings = [
        'vkazdevwordpressstacc01.blob.core.windows.net',
        'vkazprodwordpressstacc01.blob.core.windows.net',
        'cdn.valtiokonttori.fi',
        'cdn-dev.valtiokonttori.fi',
        'cdn-qa.valtiokonttori.fi',
        'cdn-prod.valtiokonttori.fi',
        'yrityksendigitalous.fi',
        'granskaforvaltningen.fi',
        'exploreadministration.fi'
    ];
    //External link is not applied if the link class attribute contains some of the following:
    var excludedClassNames = [
        'heateor_sss',
        'icon-twitter',
        'icon-x',
        'icon-linkedin',
        'icon-facebook',
        'icon-instagram',
        'social-icon',
        'main-video-link',
        'language-switcher-selection',
        'gallery-file-link',
        'vk-chart-link',
    ];

    jQuery('.off-canvas-wrapper').find('a').each(function(){
        var className = this.className;
        var hostName = this.hostname;

        // Do not apply external link attributes if the link is inside vk-chart-container
        if (jQuery(this).closest('.vk-chart-container').length == 0) {
            return;
        }

        // Open internal pdf links in new tab, open all other links in the same tab 
        // (remove target _blanks from non-pdf links if present)
        if(jQuery(this)[0].hasAttribute('href')){
            if(jQuery(this).attr('href').toLowerCase().endsWith('.pdf') && (this.hostname == location.hostname || excludedStrings.some(function(v) { return hostName.indexOf(v) >= 0; }))){
                var text = jQuery(this).text();
                jQuery(this).attr('target', '_blank').attr('aria-label', text+' - '+external_links_strings.pdf_link_aria_label);
            }else if(jQuery(this)[0].hasAttribute('target')){
                if (!excludedClassNames.some(function(v) { return className.indexOf(v) >= 0; })) {
                    jQuery(this).removeAttr('target');
                }
            }
        }

        //If links hostname is different than pages hostname and does not contain excluded strings
        //then we determine it's an external link
        if(this.hostname
            && this.hostname.replace('www.', '') !== location.hostname.replace('www.', '')
            && this.hostname.replace('qa.', '') !== location.hostname.replace('qa.', '')){
            if(!excludedStrings.some(function(v) { return hostName.indexOf(v) >= 0; }) && !excludedClassNames.some(function(v) { return className.indexOf(v) >= 0; })){
                //Remove > characters at the end of link text
                if(jQuery(this).closest('.customer-service-item').length > 0 && jQuery(this).find('*').length > 0){
                    var first = jQuery(this).children().first();
                    jQuery(first).addClass('external');

                    jQuery(this).children().each(function(){
                        var text = jQuery(this).text().replace(/\s?\>$/, '');
                        jQuery(this).text(text);
                    });
                    var labelText = jQuery(this).text()+', '+external_links_strings.external_link_aria_label;
                    jQuery(this).addClass('external-container').attr('aria-label', labelText);
                }else{
                    if(jQuery(this).find('*').length == 0){
                        this.text = this.text.replace(/\s?\>$/, '');
                    }
                    var labelText = jQuery(this).text()+', '+external_links_strings.external_link_aria_label;
                    jQuery(this).addClass('external').attr('aria-label', labelText);
                }
            }
        }
    });
});